//
import { useEffect } from "react";
import { useSelector } from "react-redux";
//component
//redux
//selector
import { bailiffDialogUrlAudioSelector } from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
//actions

const TriggerInit = ({ setAudio, setDuration = () => {} }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const url = useSelector(bailiffDialogUrlAudioSelector);

  // -------------------------- USE EFFECT ---------------------
  // trigger url.
  useEffect(() => {
    if (!url) return;
    const audio = new Audio(url);
    const sub = audio.addEventListener("canplay", () => {
      setAudio(audio);
    });

    const subMeta = audio.addEventListener("loadedmetadata", () => {
      const durationInSeconds = audio.duration;
      setDuration(durationInSeconds);
    });

    return () => {
      // Pause the audio, remove its source to release resources.
      audio.removeEventListener("canplay", sub);
      audio.removeEventListener("loadedmetadata", subMeta);
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
    };
  }, [setAudio, url]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
